import { SHIPMENT_SOLUTION_TYPES } from "~/cores/shipment.core";

import { createMockProduct, createProductsAndExchangeToProductsFn, createReturnReasonConfigBottom } from "../mockCore";

const productData1 = {
    product: createMockProduct({
        id: 1,
        productName: "Ash wool teddy jacket",
        imageSrc: "/mocks/Ahlvar-Gallery-jacket-green.jpg",
        purchasePrice: 3395,
        properties: [
            {
                type: "Size",
                value: "S",
            },
            {
                type: "Color",
                value: "Deep forest",
            },
        ],
    }),
    // exchangeAlternativesData: [{
    //     "imageUrl": "/mocks/Ahlvar-Gallery-jacket-green.jpg",
    //     "properties": [
    //         {
    //             "type": "Color",
    //             "value": "Deep forest"
    //         },
    //         {
    //             "type": "Size",
    //             "value": "XS"
    //         }
    //     ]
    // },
    //     {
    //         "originalVariant": true,
    //         "imageUrl": "/mocks/Ahlvar-Gallery-jacket-green.jpg",
    //         "properties": [
    //             {
    //                 "type": "Color",
    //                 "value": "Deep forest"
    //             },
    //             {
    //                 "type": "Size",
    //                 "value": "S"
    //             }
    //         ]
    //     },
    //     {
    //         "inventoryTurnr": 0,
    //         "imageUrl": "/mocks/Ahlvar-Gallery-jacket-green.jpg",
    //         "properties": [
    //             {
    //                 "type": "Color",
    //                 "value": "Deep forest"
    //             },
    //             {
    //                 "type": "Size",
    //                 "value": "L"
    //             }
    //         ]
    //     }, {
    //         "inventoryMerchant": 2,
    //         "imageUrl": "/mocks/Ahlvar-Gallery-jacket-black.webp",
    //         "properties": [
    //             {
    //                 "type": "Color",
    //                 "value": "Black"
    //             },
    //             {
    //                 "type": "Size",
    //                 "value": "XS"
    //             }
    //         ]
    //     },
    //     {
    //         "imageUrl": "/mocks/Ahlvar-Gallery-jacket-black.webp",
    //         "properties": [
    //             {
    //                 "type": "Color",
    //                 "value": "Black"
    //             },
    //             {
    //                 "type": "Size",
    //                 "value": "S"
    //             }
    //         ]
    //     },
    //     {
    //         "imageUrl": "/mocks/Ahlvar-Gallery-jacket-black.webp",
    //         "properties": [
    //             {
    //                 "type": "Color",
    //                 "value": "Black"
    //             },
    //             {
    //                 "type": "Size",
    //                 "value": "M"
    //             }
    //         ]
    //     },
    // ]
};

const productData2 = {
    product: createMockProduct({
        id: 2,
        productName: "Noma trousers",
        imageSrc: "/mocks/Ahlvar-Gallery-pants-green.webp",
        purchasePrice: 2095,
        returnReasonConfig: createReturnReasonConfigBottom(),
        properties: [
            {
                type: "Size",
                value: "M",
            },
            {
                type: "Color",
                value: "Deep forest",
            },
        ],
    }),
    // exchangeAlternativesData: [
    //     {
    //         "imageUrl": "/mocks/Ahlvar-Gallery-pants-black.webp",
    //         "properties": [
    //             {
    //                 "type": "Color",
    //                 "value": "Black"
    //             },
    //             {
    //                 "type": "Size",
    //                 "value": "L"
    //             }
    //         ]
    //     },
    //     {
    //         "inventoryMerchant": 0,
    //         "imageUrl": "/mocks/Ahlvar-Gallery-pants-sand.webp",
    //         "properties": [
    //             {
    //                 "type": "Color",
    //                 "value": "Sand"
    //             },
    //             {
    //                 "type": "Size",
    //                 "value": "S"
    //             }
    //         ]
    //     },
    //     {
    //         "inventoryTurnr": 0,
    //         "imageUrl": "/mocks/Ahlvar-Gallery-pants-sand.webp",
    //         "properties": [
    //             {
    //                 "type": "Color",
    //                 "value": "Sand"
    //             },
    //             {
    //                 "type": "Size",
    //                 "value": "L"
    //             }
    //         ]
    //     },
    //     {
    //         "imageUrl": "/mocks/Ahlvar-Gallery-pants-green.webp",
    //         "properties": [
    //             {
    //                 "type": "Color",
    //                 "value": "Deep forest"
    //             },
    //             {
    //                 "type": "Size",
    //                 "value": "S"
    //             }
    //         ]
    //     },
    //     {
    //         "inventoryMerchant": 0,
    //         "imageUrl": "/mocks/Ahlvar-Gallery-pants-green.webp",
    //         "properties": [
    //             {
    //                 "type": "Color",
    //                 "value": "Deep forest"
    //             },
    //             {
    //                 "type": "Size",
    //                 "value": "M"
    //             }
    //         ]
    //     },
    //     {
    //         "imageUrl": "/mocks/Ahlvar-Gallery-pants-white.webp",
    //         "properties": [
    //             {
    //                 "type": "Color",
    //                 "value": "Off-white"
    //             },
    //             {
    //                 "type": "Size",
    //                 "value": "S"
    //             }
    //         ]
    //     },
    //     {
    //         "inventoryTurnr": 0,
    //         "imageUrl": "/mocks/Ahlvar-Gallery-pants-white.webp",
    //         "properties": [
    //             {
    //                 "type": "Color",
    //                 "value": "Off-white"
    //             },
    //             {
    //                 "type": "Size",
    //                 "value": "M"
    //             }
    //         ]
    //     }
    // ]
};

const productData3 = {
    product: createMockProduct({
        id: 3,
        productName: "Pim silk satin",
        imageSrc: "/mocks/Ahlvar-Gallery-silk-sand.webp",
        purchasePrice: 1795,
        properties: [
            {
                type: "Size",
                value: "S",
            },
            {
                type: "Color",
                value: "Sand",
            },
        ],
    }),
    // exchangeAlternativesData: [
    //     {
    //         "inventoryTurnr": 0,
    //         "imageUrl": "/mocks/Ahlvar-Gallery-silk-sand.webp",
    //         "properties": [
    //             {
    //                 "type": "Color",
    //                 "value": "Sand"
    //             },
    //             {
    //                 "type": "Size",
    //                 "value": "XS"
    //             },
    //         ]
    //     },
    //     {
    //         "imageUrl": "/mocks/Ahlvar-Gallery-silk-green.webp",
    //         "properties": [
    //             {
    //                 "type": "Color",
    //                 "value": "Military green"
    //             },
    //             {
    //                 "type": "Size",
    //                 "value": "M"
    //             }
    //         ]
    //     },
    //     {
    //         "inventoryMerchant": 0,
    //         "imageUrl": "/mocks/Ahlvar-Gallery-silk-black.webp",
    //         "properties": [
    //             {
    //                 "type": "Color",
    //                 "value": "Black"
    //             },
    //             {
    //                 "type": "Size",
    //                 "value": "L"
    //             }
    //         ]
    //     },
    //     {
    //         "imageUrl": "/mocks/Ahlvar-Gallery-silk-white.webp",
    //         "properties": [
    //             {
    //                 "type": "Color",
    //                 "value": "Off-white"
    //             },
    //             {
    //                 "type": "Size",
    //                 "value": "XL"
    //             }
    //         ]
    //     }
    // ]
};

const productsAndExchangeToProductsFn = createProductsAndExchangeToProductsFn([productData1, productData2, productData3]);

export function getExchangeToProducts({ productId }) {
    return productsAndExchangeToProductsFn.exchangeToProductsFn({ productId });
}

export function getProducts() {
    return {
        sessionId: "170bfc7b-8910-43a7-8903-52c9894ed015",
        pickupDateSelectionAllowed: true,
        shipmentSolutions: [
            {
                carrier: "DHL_EXPRESS",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 0,
            },
            {
                carrier: "BUDBEE",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 39,
            },
            {
                carrier: "POSTNORD",
                type: SHIPMENT_SOLUTION_TYPES.PRINT_LABEL.key,
                cost: 39,
            },
        ],
        paidShipping: 40,
        turnrShippingCost: 59,
        currencyCode: "SEK",
        refundOptions: [
            {
                type: "BASIC",
            },
            {
                type: "GIFT_CARD",
                bonusPercentage: 0.2,
            },
        ],
        products: productsAndExchangeToProductsFn.products,
    };
}
